module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md6": "",
      "lg6": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Регистрация в системе")])], 1), _vm._v(" "), _c('v-card-text', [_vm._v("\n          В Системе \"АТЛАНТ-СМАРТ\" могут работать только представители компаний.\n          "), _c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-btn', {
    on: {
      "click": _vm.selectClient
    }
  }, [_vm._v("Указать компанию")])], 1), _vm._v(" "), _c('div', [(!!_vm.company.name) ? _c('div', [_c('b', [_vm._v(_vm._s(_vm.company.name.value))])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!!_vm.company.inn),
      expression: "!!company.inn"
    }]
  }, [_vm._v("\n            ИНН: "), _c('b', [_vm._v(_vm._s(_vm.formats.formatInn(_vm.company.inn)))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!!_vm.company.address),
      expression: "!!company.address"
    }]
  }, [_vm._v("\n            Адрес: "), _c('b', [_vm._v(_vm._s(!!_vm.company.address ? _vm.company.address.value : ''))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!!_vm.company.heads),
      expression: "!!company.heads"
    }]
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatHeads(_vm.company.heads))
    }
  })]), _vm._v(" "), _c('p'), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!!_vm.company.heads),
      expression: "!!company.heads"
    }]
  }, [_c('b', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatHeadNames(_vm.company.heads))
    }
  }), _vm._v(",")]), _vm._v(" если это Вы, то укажите эл. почту для направления Вам счета с реквизитами для совершения Вашей компанией удостоверяющего платежа.\n            ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!!_vm.company.heads),
      expression: "!!company.heads"
    }],
    attrs: {
      "label": "Введите адрес эл. почты для посылки счета",
      "rules": _vm.emailRules,
      "type": "text",
      "clearable": ""
    },
    model: {
      value: (_vm.request.email),
      callback: function($$v) {
        _vm.$set(_vm.request, "email", $$v)
      },
      expression: "request.email"
    }
  }), _vm._v(" "), _c('div', [_c('div', [_c('a', {
    attrs: {
      "href": _vm.getDepoUrl(_vm.getOpenSettings.useRules)
    }
  }, [_vm._v("Лицензионное соглашение")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": _vm.getDepoUrl(_vm.getOpenSettings.personInfoRules)
    }
  }, [_vm._v("Политика обработки персональных данных")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": _vm.getDepoUrl(_vm.getOpenSettings.personInfoAgreement)
    }
  }, [_vm._v("Согласие на обработку персональных данных")])]), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Даю согласие",
      "persistent-hint": "",
      "hint": "Политику обработки персональных данных изучил, Даю свое соглашение на обработку моих персональных данных"
    },
    model: {
      value: (_vm.personAgreementCheck),
      callback: function($$v) {
        _vm.personAgreementCheck = $$v
      },
      expression: "personAgreementCheck"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "block": "",
      "disabled": !_vm.valid || !this.request.inn || !_vm.personAgreementCheck,
      "color": "primary"
    },
    on: {
      "click": _vm.registerRequest
    }
  }, [_vm._v("Получить счет")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54e313be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/Register.vue
// module id = 985
// module chunks = 1